// Test User Class
// --------------------
// Mirrors the back end or graph call
// Supposed to be a simple storage container
//

interface TestUserDict {
  id: string;
  owner: string | null;
  dateAdded: Date;
  password: string | null;
  pin: string | null;
  totpSecret: string | null;
  userPriority: number;
  username: string | null;
}

class TestUserClass {
  id: string;
  owner: string | null;
  dateAdded: Date;
  password: string | null;
  pin: string | null;
  totpSecret: string | null;
  userPriority: number;
  username: string | null;

  constructor(testUserDict?: TestUserDict) {
    this.id = "";
    this.owner = null;
    this.dateAdded = new Date();
    this.password = null;
    this.pin = null;
    this.totpSecret = null;
    this.userPriority = 0;
    this.username = null;

    if (testUserDict) {
      this.id = testUserDict.id;
      this.owner = testUserDict.owner;
      this.dateAdded = testUserDict.dateAdded;
      this.password = testUserDict.password;
      this.pin = testUserDict.pin;
      this.totpSecret = testUserDict.totpSecret ?? null;
      this.userPriority = testUserDict.userPriority;
      this.username = testUserDict.username;
    }
  }

  setSimpleValues(
    username: string,
    password: string,
    pin: string,
    priority: number,
    totpSecret: string = ""
  ): void {
    this.username = username;
    this.password = password;
    this.pin = pin;
    this.totpSecret = totpSecret;
    this.userPriority = priority;
  }
}

export default TestUserClass;
